'use client';

import { useRef } from 'react';
import { cx } from './cx';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Нажали крестик (или Escape при непустом поле). Без него поле просто очищается. */
  onClear?: () => void;
  autoFocus?: boolean;
  /** Подпись для скринридера, если подсказки мало. */
  ariaLabel?: string;
  className?: string;
  /** Фокус в поле (режим поиска у «Ботов»/«Чатов»: шапка уступает место строке). */
  onFocus?: () => void;
  onBlur?: () => void;
};

/** Строка поиска набора — `.k-search` в kit.css (родной `ScrSearchBar`, Э4.10): капсула,
 *  лупа слева, крестик справа — только при непустом значении. */
export function KSearch({ value, onChange, placeholder, onClear, autoFocus, ariaLabel, className, onFocus, onBlur }: Props) {
  const inp = useRef<HTMLInputElement | null>(null);
  const clear = () => {
    if (onClear) onClear();
    else onChange('');
    inp.current?.focus();
  };
  return (
    <label className={cx('k-search', className)}>
      <svg className="k-search__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" aria-hidden="true">
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="m15.5 15.5 4.5 4.5" />
      </svg>
      <input
        ref={inp}
        className="k-search__inp"
        type="search"
        enterKeyHint="search"
        autoComplete="off"
        spellCheck={false}
        autoFocus={autoFocus}
        value={value}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={(e) => {
          if (e.key === 'Escape' && value) {
            e.preventDefault();
            clear();
          }
        }}
      />
      {value ? (
        <button type="button" className="k-round k-round--sm k-round--ghost k-search__x" aria-label="Очистить" onClick={clear}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" aria-hidden="true">
            <path d="M7 7l10 10M17 7 7 17" />
          </svg>
        </button>
      ) : null}
    </label>
  );
}
